import React from 'react';
import { useField } from 'formik';

import FileInput from './FileInput.jsx';
import FileClick from './FileClick.jsx';
import FileDrop from './FileDrop.jsx';

const FieldFileInput = ({
  api,
  fileOpts,
  ...props
}) => {
  const [, { value }, { setTouched, setValue }] = useField(props);
  const onFileAdd = async ([f]) => {
    setValue(f);
  };

  return (
    <div className="position-relative">
      <FileDrop className="" onDrop={onFileAdd} {...fileOpts}>
        <FileClick className="" onFile={onFileAdd} {...fileOpts}>
          <FileInput
            {...props}
            api={{ url: api }}
            value={value}
            onChange={(v) => {
              setValue(v);
              setTouched();
            }}
          >
            Drop your file or <u>Browse</u>
          </FileInput>
        </FileClick>
      </FileDrop>
    </div>
  );
};

export default FieldFileInput;
